export default {
  userSegments: [],
  displayData: [],
  data: {},
  saved: true,
  showDataFillingHint: false,
};
